export const TAG_VARIANT = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  SUCCESS: 'success',
  ALERT: 'alert',
  DANGER: 'danger',
  NEUTRAL: 'neutral',
  GOLD: 'gold',
  DEFAULT: 'default',
} as const;

export type TagVariant = (typeof TAG_VARIANT)[keyof typeof TAG_VARIANT];

export const TAG_TEXT_TRANSFORM = {
  NONE: 'none',
  CAPITALIZE: 'capitalize',
  UPPERCASE: 'uppercase',
  UPPERFIRST: 'upperfirst',
} as const;

export type TagTextTransform =
  (typeof TAG_TEXT_TRANSFORM)[keyof typeof TAG_TEXT_TRANSFORM];
